import type { ReactNode } from 'react';
import { Head } from '@inertiajs/react';

import ProsopiteErrorNotifier from '@/components/development/prosopite-error-notifier';
import InertiaMetaTags from '@/components/inertia-meta-tags';
import { Toaster } from '@/components/ui/toast';

export default function BlankLayout({
  children,
  showProsopiteErrorNotifier = true,
}: {
  children: ReactNode;
  showProsopiteErrorNotifier?: boolean;
}) {
  return (
    <>
      <InertiaMetaTags />
      <Head></Head>

      <div id="blank-layout">
        <Toaster />
        {showProsopiteErrorNotifier && <ProsopiteErrorNotifier />}
        {children}
      </div>
    </>
  );
}
